module.exports = __webpack_public_path__ + "laserove-beleni-zubu_3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/special/laserove-beleni-zubu_3.jpg
// module id = 911
// module chunks = 0